import { Alert } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

interface AccessLinkExpiredAlertProps {
  message?: string | null;
}

export const AccessLinkExpiredAlert: React.FC<AccessLinkExpiredAlertProps> = ({ message }) => {
  const { formatMessage } = useIntl();
  return (
    <Alert severity="warning">
      {message || formatMessage({ id: 'The access link has expired.' })}
    </Alert>
  );
};
